export default __webpack_public_path__ + "static/media/facebook-filled.b0b5c605.svg";